module.exports = __webpack_public_path__ + "img/left_normal.7681c7ca.png";